import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Header, Segment, Feature, NeuCard, ButtonFA } from 'components';
import { colors } from 'utils/colors';
import { BuildCustom, BuildETF, CacheInputs } from 'actions';
import {
  PORTFOLIOS_CREATE_NEW,
  PORTFOLIOS_VIEW_SAVED,
  PORTFOLIOS_VIEW_MODEL,
} from 'utils/features';
import asset7 from 'images/asset_7.png';
import {
  faFolderOpen,
  // eslint-disable-next-line import/extensions
} from '@fortawesome/free-solid-svg-icons';

@withRouter
@connect((state) => ({
  account: state.CustomAccount.account,
}))
class Landing extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(BuildCustom.removeAll());
    dispatch(BuildCustom.updateToggle('addGicToggle', false));
    dispatch(BuildCustom.updateToggle('addBtcToggle', false));
    dispatch(BuildETF.clearBuildETF());

    return dispatch(CacheInputs.clearField('portfolios', 'smart_risk_builder'));
  }

  render() {
    const { history } = this.props;
    return (
      <Segment expand>
        <Feature name={PORTFOLIOS_VIEW_SAVED}>
          <ButtonFA
            className="left"
            color={colors.teal}
            style={{
              backgroundColor: 'white',
              display: 'block',
              marginBottom: '5px',
              position: 'absolute',
              top: '2.5rem',
              right: '3.3rem',
            }}
            icon={faFolderOpen}
            onClick={() => {
              history.push(`/portfolio/user`);
            }}
          >
            See Saved Simulations
          </ButtonFA>
        </Feature>
        <div>
          <img src={asset7} height="80" width="120" alt="Portfolio" />
          <Header size="1.5rem" color="black">
            Welcome to Simulations
          </Header>
          <P>
            Let us help you build and analyze a new portfolio. Once created, you
            will see the Wealthscope Portfolio Scorecard and all the relevant
            analytics. You will be able to save it here in the Wealthscope app,
            and revisit and edit it in the future. Note: Portfolios saved here
            will not appear in Quotestream.
          </P>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            <Feature name={PORTFOLIOS_CREATE_NEW}>
              <NeuCard
                to="/portfolio/create"
                iconName="file"
                title="Create New"
                description="Build and analyze a new simulation."
                color={colors.teal}
              />
            </Feature>
            <Feature name={PORTFOLIOS_VIEW_MODEL}>
              <NeuCard
                to="/portfolio/model"
                iconName="flag"
                title="View our Model Portfolios"
                description="See five simple ETF portfolios that have been optimized for different investor risk profiles."
                color={colors.teal}
              />
            </Feature>
          </div>
        </div>
      </Segment>
    );
  }
}

export default Landing;

Landing.propTypes = {
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

const P = styled.p`
  color: rgba(0, 0, 0, 0.5) !important;
  max-width: 650px;
  margin: 0 auto 3rem auto;

  &.strike {
    text-decoration: line-through;
  }
`;
